// External URLs and CDN endpoints
export const EXTERNAL_URLS = {
  // S3 Bucket URLs
  S3_BASE_URL: process.env.REACT_APP_S3_BASE_URL || 'https://sbr2th-prod-data.s3.amazonaws.com',
  
  // Video URLs
  VIDEOS: {
    LANDING_PAGE: process.env.REACT_APP_LANDING_VIDEO_URL || 'https://sbr2th-prod-data.s3.amazonaws.com/landing-page1.mp4',
    DOCUMENT_TUTORIAL: process.env.REACT_APP_DOCUMENT_VIDEO_URL || 'https://sbr2th-prod-data.s3.amazonaws.com/company_candidates_docs/document1.mp4',
    AI_TUTORIAL: process.env.REACT_APP_AI_VIDEO_URL || 'https://sbr2th-prod-data.s3.amazonaws.com/company_candidates_docs/ai1.mp4',
  },
  
  // Social Media URLs
  SOCIAL: {
    LINKEDIN: process.env.REACT_APP_LINKEDIN_URL || 'https://www.linkedin.com/company/sbr2th/',
  },
  
  // Google OAuth URLs
  GOOGLE: {
    USER_INFO: 'https://www.googleapis.com/oauth2/v3/userinfo',
  },
  
  // Development URLs
  DEVELOPMENT: {
    FRONTEND_URL: process.env.REACT_APP_FRONTEND_URL || 'http://localhost:3000',
    API_URL: process.env.REACT_APP_API_URL || 'http://localhost:8001',
  }
};

// Helper function to get S3 video URL
export const getS3VideoUrl = (videoPath: string): string => {
  return `${EXTERNAL_URLS.S3_BASE_URL}/${videoPath}`;
};

// Helper function to get Google OAuth user info URL
export const getGoogleUserInfoUrl = (accessToken: string): string => {
  return `${EXTERNAL_URLS.GOOGLE.USER_INFO}?access_token=${accessToken}`;
};
